import { render, staticRenderFns } from "./mock.vue?vue&type=template&id=a7da3138"
import script from "./mock.vue?vue&type=script&lang=js"
export * from "./mock.vue?vue&type=script&lang=js"
import style0 from "./mock.vue?vue&type=style&index=0&id=a7da3138&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports